<template>
  <v-login
    :title="title"
    is-wide
  >
    <form
      v-if="!submit"
      action
      @submit.prevent="register"
    >
      <v-step-indicator
        class="mb-4"
        :statuses="statuses"
      />
      <div>
        <template v-if="step === 1">
          <v-label text="Select User Type*" />
          <fieldset class="fieldset">
            <v-checkbox
              v-for="role in defaultRoles"
              :id="role.id"
              :key="role.id"
              :value="role.value"
              :checked="containsObject(role,form.roles)"
              @check="checkInObj(role,form.roles)"
            >
              {{ role.value }}
            </v-checkbox>
            <v-input-help
              v-if="roleCheckError"
              class="fieldset__text"
              :text="roleCheckError"
            />
          </fieldset>
          <div class="row">
            <v-fieldset
              id="first_name"
              v-model="form.first_name"
              class="col-md-6"
              text="First Name*"
              placeholder="First Name"
              :is-required="true"
              :help-text="validationErrors.first_name"
            />
            <v-fieldset
              id="last_name"
              v-model="form.last_name"
              class="col-md-6"
              text="Last Name*"
              placeholder="Last Name"
              :is-required="true"
              :help-text="validationErrors.last_name"
            />
            <v-fieldset
              id="title"
              v-model="form.title"
              class="col-md-6"
              text="Position Title*"
              placeholder="Title"
              :is-required="true"
              :help-text="validationErrors.title"
            />
            <v-fieldset
              id="mobile_number"
              v-model="form.mobile_number"
              class="col-md-6"
              text="Phone*"
              pattern="[0-9]+"
              placeholder="Phone Number"
              :is-required="true"
              :help-text="validationErrors.mobile_number"
            />
            <v-fieldset
              id="email"
              v-model="form.email"
              class="col-md-6"
              text="Email*"
              type="email"
              placeholder="Email"
              :is-required="true"
              :help-text="validationErrors.email"
            />
            <v-fieldset
              id="address"
              v-model="form.address"
              class="col-md-6"
              text="Address*"
              placeholder="Address"
              :is-required="true"
              :help-text="validationErrors.address"
            />
            <v-fieldset
              id="country"
              v-model="form.country"
              class="col-md-6"
              text="Country"
              placeholder="Country"
              :help-text="validationErrors.country"
            />
            <v-fieldset
              v-if="states.length > 0"
              id="state"
              v-model="state"
              class="col-md-6"
              text="State"
              placeholder=" "
              :select-options="states"
              :help-text="validationErrors.state"
            />
            <v-fieldset
              id="suburb"
              v-model="form.suburb"
              class="col-md-6"
              text="Suburb"
              placeholder="Suburb"
              :help-text="validationErrors.suburb"
            />
            <v-fieldset
              id="postcode"
              v-model="form.postcode"
              class="col-md-6"
              pattern="^[0-9]+$"
              text="Post Code"
              placeholder="Post Code"
              :help-text="validationErrors.postcode"
            />
            <v-fieldset
              v-if="valueExistInObjArray(constants.NATA_ROLE_TA,form.roles)"
              id="userId"
              v-model="form.userId"
              class="col-md-6"
              placeholder="User ID"
              text="User ID"
              :is-required="valueExistInObjArray(constants.NATA_ROLE_TA,form.roles)"
              :help-text="validationErrors.userId"
            />
          </div>
        </template>
        <template v-else-if="step === 2">
          <div
            v-for="(item,index) in form.facilities"
            :key="index"
            class="mb-4"
          >
            <v-headline
              :text="'Facility '+ setFacilitySeq(index)"
              :level="4"
            >
              <v-button
                v-if="index > 0"
                color="transparent"
                @click="delFacility(index)"
              >
                <v-icon type="times" />
              </v-button>
            </v-headline>
            <div class="row">
              <v-fieldset
                :id="'facility_number ' + index"
                v-model="item.facility_number"
                class="col-md-6"
                text="Facility Accreditation Number*"
                placeholder="Please input facility number"
                :is-required="true"
                :readonly="checkEditable(index,'facility_name')"
                @keyup="getFacility($event, index)"
              />
              <v-fieldset
                :id="'facility ' + index"
                v-model="item.facility_name"
                class="col-md-6"
                text="Facility Name*"
                placeholder="Facility name"
                :is-required="true"
                :readonly="true"
              />
            </div>
            <fieldset
              v-if="item.allSites.length>0"
              class="fieldset"
            >
              <v-checkbox
                v-for="site in item.allSites"
                :id="site.site_number"
                :key="site.site_number"
                :value="site.site_number"
                :checked="containsObject(site,item.sites,true)"
                @check="checkInObj(site,item.sites,true)"
              >
                {{ site.site_number }} - {{ site.name }}
              </v-checkbox>
            </fieldset>
          </div>
          <v-button
            color="secondary"
            @click="addFacility()"
          >
            <v-icon type="plus" />
            Add Facility
          </v-button>
        </template>
        <template v-else-if="step === 3">
          <fieldset class="fieldset">
            <v-label text="Select at least One or More Committees if Applicable from the List of Committees" />
            <v-checkbox
              v-for="committee in committees"
              :id="committee.id"
              :key="committee.id"
              :value="committee.value"
              :checked="containsObject(committee,form.committees,true)"
              @check="checkInObj(committee,form.committees)"
            >
              {{ committee.value }}
            </v-checkbox>
          </fieldset>
        </template>
        <template v-else-if="step === 4">
          <div v-if="generalPublicationCat.length > 0">
            <strong>Select from the List of Publications</strong>
            <fieldset class="fieldset">
              <v-checkbox-list
                id="general"
                v-model="form.subscriptions[0].selected"
                :groups="generalPublicationCat"
                :selected-group="form.subscriptions[0].selected"
                @change="userSubscriptionChange"
              />
            </fieldset>
          </div>
        </template>
        <template v-else-if="step === 5">
          <v-headline
            text="Personal Details"
            :level="4"
          >
            <v-button
              color="transparent"
              @click="setStep(1)"
            >
              <v-icon
                type="edit"
              />
            </v-button>
          </v-headline>
          <v-data-list :data="personalDetails" />
          <div v-if="facilityDetailIsReady">
            <v-headline
              text="SITE/FACILITY ACCESS Details"
              :level="4"
            >
              <v-button
                color="transparent"
                @click="setStep(2)"
              >
                <v-icon
                  type="edit"
                />
              </v-button>
            </v-headline>
            <v-data-list
              v-for="facility in form.facilities"
              :key="facility.facility_number"
              :data="formatFacility(facility)"
            />
          </div>
          <div v-if="form.committees.length > 0">
            <v-headline
              text="SELECT COMMITTEE"
              :level="4"
            >
              <v-button
                color="transparent"
                @click="setStep(3)"
              >
                <v-icon
                  type="edit"
                />
              </v-button>
            </v-headline>
            <fieldset class="fieldset">
              <v-label text="Select at least One or More Committees if Applicable from the List of Committees" />
              <v-list :items="form.committees" />
            </fieldset>
          </div>
          <div v-if="form.subscriptions.length > 0">
            <v-headline
              text="SUBSCRIPTIONS"
              :level="4"
            >
              <v-button
                color="transparent"
                @click="setStep(4)"
              >
                <v-icon
                  type="edit"
                />
              </v-button>
            </v-headline>
            <template v-if="form.subscriptions[0].selected.length > 0">
              <strong>Select from the List of Publications</strong>
              <v-list :items="form.subscriptions[0].selected" />
            </template>
          </div>
          <div
            v-if="valueExistInObjArray(constants.NATA_ROLE_TA, form.roles) ||
              valueExistInObjArray(constants.NATA_ROLE_CM, form.roles)"
          >
            <fieldset class="fieldset">
              <v-checkbox
                id="accept-terms"
                value="accept"
                :checked="form.signature.accept"
                @check="form.signature.accept = !form.signature.accept"
              >
                I have read and agree to the <span
                  class="text--underline"
                  @click="showTerms"
                >Terms and Conditions</span> of use for the portal.
              </v-checkbox>
            </fieldset>
            <div class="row">
              <v-fieldset
                id="signatureName"
                v-model="form.signature.name"
                class="col-md-6"
                text="Name*"
                placeholder="Name"
                :is-required="true"
              />
              <v-fieldset
                id="signatureTitle"
                v-model="form.signature.title"
                class="col-md-6"
                text="Position Title*"
                placeholder="Position Title"
                :is-required="true"
              />
              <v-fieldset
                id="signatureDate"
                v-model="form.signature.date"
                class="col-md-6"
                text="Date*"
                type="date"
                placeholder="Accept Date('YYYY-MM-DD')"
                :is-required="true"
              />
            </div>
          </div>
        </template>
      </div>
      <v-button-group class="justify-content-center mt-auto">
        <v-button
          v-if="!readyToSubmit || step !== 5"
          size="lg"
          has-min-width
          @click="nextStep"
        >
          Proceed
        </v-button>
        <v-button
          v-if="step === 5"
          :is-disabled="!readyToSubmit || !signatureIsReady"
          class="mt-auto"
          size="lg"
          has-min-width
          @click="register"
        >
          Submit
        </v-button>
      </v-button-group>
    </form>
    <div
      v-if="submit"
      class="text--center"
    >
      <v-alert
        icon="check-circle"
        color="success"
        is-large
      >
        {{ successMsg }}
      </v-alert>
      <router-link
        color="transparent"
        :to="'/login'"
      >
        Back to Login
      </router-link>
    </div>
    <v-modal
      v-if="showModal"
      @close="showModal = false"
    >
      <template #header>
        {{ ModalTitle }}
      </template>
      <span v-html="ModalBody" />
      <template #footer>
        <v-button-group is-right>
          <v-button
            color="secondary"
            size="lg"
            has-min-width
            @click="showModal = false"
          >
            Cancel
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </v-login>
</template>
<script>
  import Login from "@/templates/Login";
  import StepIndicator from "@/molecules/StepIndicator";
  import DataList from "@/atoms/DataList";
  import Button from "@/atoms/Button";
  import Alert from "@/atoms/Alert";
  import Icon from "@/atoms/Icon";
  import Headline from "@/atoms/Headline";
  import Checkbox from "@/atoms/Checkbox";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Modal from "@/atoms/Modal";
  import Fieldset from "@/molecules/Fieldset";
  import InputHelp from "@/atoms/InputHelp";
  import Label from "@/atoms/Label";
  import List from "@/molecules/List";
  import CheckboxList from "@/molecules/CheckboxList";
  import {GET_FACILITY_INFO, REGISTRATION, GET_COMMITTEE_NAMES, GET_PUBLICATION_CATEGORIES, GET_ALL_PUBLICATION_CATEGORIES } from "../store/actions.type";
  import constants from "@/common/constants";
  import htmlConstants from "@/common/htmlConstants";
  import {buildDefinitionList, zeroPad} from "../common/tableFunctions";

  export default {
    name: "Register",
    components: {
      "v-login": Login,
      "v-step-indicator": StepIndicator,
      "v-checkbox": Checkbox,
      "v-data-list": DataList,
      "v-headline": Headline,
      "v-icon": Icon,
      "v-alert": Alert,
      "v-button": Button,
      "v-modal": Modal,
      "v-button-group": ButtonGroup,
      "v-fieldset": Fieldset,
      "v-input-help": InputHelp,
      "v-list":List,
      "v-checkbox-list": CheckboxList,
      "v-label": Label,
    },
    data() {
      return {
        title: "Registration Details",
        step: 1,
        maxStep: 3,
        statuses: [],
        updatedSubscription: [],
        defaultRoles: [
          {
            "id": constants.NATA_ROLE_AR,
            "value": "Authorised Representative",
          },
          {
            "id": constants.NATA_ROLE_CM,
            "value": "Committee Member",
          },
          {
            "id": constants.NATA_ROLE_TA,
            "value": "Technical Assessor",
          },
          {
            "id": constants.NATA_ROLE_TA_ADMIN,
            "value": "Technical Assessor Admin",
          }
        ],
        states: [],
        roleIsReady: false,
        roleCheckError: '',
        personalDetailIsReady: false,
        facilityDetailIsReady: false,
        committeeIsReady: false,
        subscriptionsIsReady: false,
        readyToSubmit: false,
        facilityError: '',
        committeesErrors: '',
        submit: false,
        successMsg: 'We have saved all your details in our database and your registration form has been sent to NATA team for verification.',
        // personalSummary: ['first_name', 'last_name', 'title', 'mobile_number', 'email', 'address', 'suburb', 'state', 'country','postcode', 'userId'],
        committees: [],
        publication_categories:[],
        form:{
            email:'',
            first_name:'',
            last_name:'',
            roles:[],
            address:'',
            suburb: '',
            state: '',
            country: '',
            postcode:'',
            mobile_number:'',
            title:'',
            userId:'',
            facilities:[
              {
                "facility_number":'',
                "facility_name":'',
                "sites":[],
                "allSites":[],
              },
            ],
            committees:[],
            subscriptions:[
              {
                type:'General',
                selected: [],
              }
            ],
            signature:{
                accept: false,
                name : '',
                title : '',
                date  :''
            }
        },
        validationErrors: {},
        validationErrorsSubmit: {},
        showModal: false,
        ModalTitle: '',
        ModalBody: '',
        selectAll: false,
      }
    },
    computed: {
      state: {
        get: function () {
          return this.form.state;
        },
        set: function (newValue) {
          this.form.state = newValue
        }
      },
      generalPublicationCat(){
        return this.formatCheckboxList(this.publication_categories);
      },
      personalDetails() {
        let summary_personalDetails = [];
        if (this.valueExistInObjArray(constants.NATA_ROLE_TA, this.form.roles)) {
          summary_personalDetails = ['first_name', 'last_name', 'title', 'mobile_number', 'email', 'address', 'suburb', 'state', 'country', 'postcode', 'userId'];
        } else
          summary_personalDetails = ['first_name', 'last_name', 'title', 'mobile_number', 'email', 'address', 'suburb', 'state', 'country', 'postcode'];
        const filtered = Object.keys(this.form)
          .filter(key => summary_personalDetails.includes(key))
          .reduce((obj, key) => {
            obj[key] = this.form[key];
            return obj;
          }, {});
        let roles = this.form.roles.map(r => r.value);
        let result = {
          'Select User Type': roles.join(', '),
          'First Name': filtered.first_name,
          'Last Name': filtered.last_name,
          'Position Title': filtered.title,
          'Phone': filtered.mobile_number,
          'Email': filtered.email,
          'Address': filtered.address,
          'Suburb': filtered.suburb,
          'State': filtered.state,
          'Country': filtered.country,
          'Post Code': filtered.postcode,
          // 'User ID': filtered.userId,
        };
        if (this.valueExistInObjArray(constants.NATA_ROLE_TA, this.form.roles)) {
          result['User Id'] = filtered.userId
        }
        return buildDefinitionList(result);
      },
      signatureIsReady() {
        if (this.valueExistInObjArray(constants.NATA_ROLE_TA, this.form.roles)
          || this.valueExistInObjArray(constants.NATA_ROLE_CM, this.form.roles)) {
          return this.form.signature.accept === true &&
            this.form.signature.name != '' &&
            this.form.signature.title != '' &&
            this.form.signature.date != '';
        } else {
          return true;
        }

      }
    },
    watch: {

      'form.roles': function () {
        /*
         * add extra step indicator if AR/CM is selected
         */
        this.resetStatus();
        let AR_extra_status = {
          id: 2,
          text: 'Site/Facility Access Details',
          isActive: false
        };
        let CM_extra_status = {
          id: 3,
          text: 'Select Committee',
          isActive: false
        };
        let roles = this.form.roles;

        if (this.valueExistInObjArray(constants.NATA_ROLE_AR, roles) && this.valueExistInObjArray(constants.NATA_ROLE_CM, roles)) {
          this.addStatues(AR_extra_status, 1);
          this.addStatues(CM_extra_status, 2);
          this.maxStep = this.statuses.length;
        } else if (this.valueExistInObjArray(constants.NATA_ROLE_AR, roles)) {
          this.addStatues(AR_extra_status, 1);
          this.maxStep = this.statuses.length;
        } else if (this.valueExistInObjArray(constants.NATA_ROLE_CM, roles)) {
          this.addStatues(CM_extra_status, 1);
          this.maxStep = this.statuses.length;
        } else
          this.maxStep = this.statuses.length;

        if (!this.valueExistInObjArray(constants.NATA_ROLE_TA, roles)) {
          this.form.userId = '';
        }
        if (!this.valueExistInObjArray(constants.NATA_ROLE_AR, roles)) {
          this.form.facilities = [
            {
              "facility_number": '',
              "facility_name": '',
              "sites": [],
              "allSites": [],
            },
          ];
        }
        if (!this.valueExistInObjArray(constants.NATA_ROLE_CM, roles)) {
          this.form.committees = [];
        }
      },
      'form.committees': function () {
        if (this.form.committees.length > 0) {
          this.committeeIsReady = true;
          this.committeesErrors = '';
        } else {
          this.committeeIsReady = false;
        }
      },
      'form.country': {
        handler: function (val, oldVal) {
          // if country != 'au', force to set 'OTHER'
          if (val.toString().toLowerCase() == 'australia' || val.toString().toLowerCase() == 'au') {
            this.resetStates();
            document.getElementById('state').disabled = false;
          } else {
            this.form.state = 'Other';
            document.getElementById('state').disabled = true;
          }
        }
      },
      step: {
        handler: function (val, oldVal) {
          // from summary to one of the previous step
          if (oldVal === 5) {
            this.statuses[this.statuses.length - 1].isActive = false;
            this.statuses[this.findAttrIndex(this.statuses, 'id', val)].isActive = true;
          } else {
            let activeIndex = this.findAttrIndex(this.statuses, 'isActive', true);
            this.statuses[parseInt(activeIndex)].isActive = false;
            this.statuses[parseInt(activeIndex) + 1].isActive = true;
          }
          this.readyToSubmit = (this.step === 5);
        }
      },
      form: {
        deep: true,
        handler: function (val, oldVal) {
          for (let key in val) {
            const checkField = document.getElementById(key);
            if (checkField != null && checkField.value.length > 0) {
              const isValid = checkField.checkValidity();
              if (!isValid) {
                this.validationErrors[key] = 'Please input valid detail for  ' + checkField.placeholder;
              } else {
                delete this.validationErrors[key];
              }
            }
          }
          this.personalDetailIsReady = (Object.keys(this.validationErrors).length === 0 && this.form.roles.length > 0);
        }
      }
    },
    created () {
      this.constants = constants;
    },
    mounted() {
      this.resetStates();
      this.resetStatus();
      this.getCommitteeNames();
      this.getPublicationCat();
    },
    methods: {
      checkEditable(index, property) {
        return (this.form.facilities[index][property].length > 0);
      },
      register() {
        this.form.subscriptions = this.updatedSubscription;
        this.$store.dispatch(REGISTRATION, this.form)
          .then(response => {
            if (response.success) {
              this.submit = true;
              this.title = '';
            } else {
              for (const [key, value] of Object.entries(response.data)) {
                this.$notify({
                  title: 'Error',
                  text: value[0],
                  type: 'error'
                });
              }
            }
          });
      },
      setStep(step) {
        this.step = step
      },
      resetStatus() {
        this.statuses = [
          {
            id: 1,
            text: "Personal Details",
            isActive: true
          },
          {
            id: 4,
            text: "Subscriptions",
            isActive: false,
          },
          {
            id: 5,
            text: "Summary",
            isActive: false,
          }];
      },
      resetStates() {
        this.states = constants.USER_STATES;
      },
      addStatues(property, order) {
        this.statuses.splice(order, 0, property);
      },
      findAttrIndex(array, attr, value) {
        for (let i = 0; i < array.length; i += 1) {
          if (array[i][attr] === value) {
            return i;
          }
        }
        return -1;
      },
      validatePersonalDetails() {
        let summary_personalDetails = [];
        if (this.valueExistInObjArray(constants.NATA_ROLE_TA, this.form.roles)) {
          summary_personalDetails = ['first_name', 'last_name', 'title', 'mobile_number', 'email', 'address', 'suburb', 'state', 'country', 'postcode', 'userId'];
        } else
          summary_personalDetails = ['first_name', 'last_name', 'title', 'mobile_number', 'email', 'address', 'suburb', 'state', 'country', 'postcode'];

        let errors = {};
        for (let i = 0, len = summary_personalDetails.length; i < len; i++) {
          const checkField = document.getElementById(summary_personalDetails[i]);
          const isValid = checkField.checkValidity();
          if (!isValid)
            errors[summary_personalDetails[i]] = 'Please input valid detail for  ' + checkField.placeholder;
        }
        this.validationErrorsSubmit = errors;
      },
      nextStep() {
        /*
         * Roles/StepIndicators combinations
         * TA 1->4->5 & TA_ADMIN
         * AR 1->2->4->5
         * CM 1->3->4->5
         * TA+AR 1->2->4->5
         * TA+CM 1->3->4->5
         * TA+AR+CM 1->2->3->4->5
         */
        //Validate personal again for submit button
        if (this.step === 1) {
          this.validatePersonalDetails();
          this.validationErrors = this.validationErrorsSubmit;
          this.personalDetailIsReady = Object.keys(this.validationErrorsSubmit).length === 0 && this.form.roles.length > 0;
          this.roleCheckError = (this.form.roles.length === 0) ? 'Please select at least 1 role to proceed!' : '';
        }

        if (this.step === 1 && this.personalDetailIsReady) {
          if (this.valueExistInObjArray(constants.NATA_ROLE_CM, this.form.roles) && !this.valueExistInObjArray(constants.NATA_ROLE_AR, this.form.roles)) {
            this.step = 3
          } else if ((this.valueExistInObjArray(constants.NATA_ROLE_TA, this.form.roles) || this.valueExistInObjArray(constants.NATA_ROLE_TA_ADMIN, this.form.roles))&& this.form.roles.length === 1) {
            this.step = 4;
          } else if (this.valueExistInObjArray(constants.NATA_ROLE_AR, this.form.roles)) {
            this.step++;
          }
        } else if (this.step === 2) {
          //force to validate all the facilities input again
          this.facilityDetailIsReady = false;
          if (!this.facilityDetailIsReady) {
            for (var i = 0; i < this.form.facilities.length; i++) {
              if (this.form.facilities[i].facility_name.length > 0) {
                document.getElementById('facility_number ' + i).readOnly = true;
              }
              if (this.form.facilities[i].facility_number.length === 0) {
                this.facilityError = 'At lease one Facility should be selected or one of Facility Number is missing!';
                this.$notify({
                  title: 'Error',
                  text: this.facilityError,
                  type: 'error'
                });
                break;
              } else if (this.form.facilities[i].facility_name.length === 0) {
                this.facilityError = 'Facility Name for Facility ' + parseInt(i + 1) + ' is missing!';
                this.$notify({
                  title: 'Error',
                  text: this.facilityError,
                  type: 'error'
                });
                break;
              } else if (this.form.facilities[i].allSites.length > 0 && this.form.facilities[i].sites.length === 0) {
                this.facilityError = 'At least 1 site should be choose for Facility '+this.form.facilities[i].facility_number+' - ' + this.form.facilities[i].facility_name;
                this.$notify({
                  title: 'Error',
                  text: this.facilityError,
                  type: 'error'
                });
                break;
              } else {
                this.facilityError = '';
              }
            }
            this.facilityDetailIsReady = (this.form.facilities.length > 0 && this.facilityError.length === 0);
          }
          if (!this.valueExistInObjArray(constants.NATA_ROLE_CM, this.form.roles) && this.facilityDetailIsReady) {
            this.step = 4
          } else if (this.facilityDetailIsReady) {
            this.step++;
          }
        } else if (this.step === 3) {
          if (!this.committeeIsReady) {
            this.committeesErrors = 'At least 1 committee should be selected!';
            this.$notify({
              title: 'Error',
              text: 'At least 1 committee should be selected!',
              type: 'error'
            });
          } else {
            this.step++;
          }
        } else if (this.step === 4) {
          this.step++;
        }
      },
      checkInObj(obj, objArr, isSite, parent_id) {
        if (objArr.some(o => o.id === obj.id)) {
          objArr.splice(objArr.findIndex(o => o.id === obj.id), 1)
        } else {
            if(isSite === true){
                let temp = {};
                temp.id = obj.id;
                temp.value = obj.site_number+'-'+obj.name;
                objArr.push(temp)
            }else if(isSite === false && (obj.id === parent_id))
            {
                let temp = {};
                temp.id = obj.id;
                temp.value = obj.value ? obj.value:obj.name;
                temp.items = [];
                objArr.push(temp)
            }
            else{
                let temp = {};
                temp.id = obj.id;
                temp.value = obj.value ? obj.value:obj.name;
                objArr.push(temp)
            }
        }
      },
      checkOutObj(obj,array){
          for(var i = 0; i < array.length; i++) {
              if(array[i].id === obj.id) {
                  array.splice(i, 1);
                  break;
              }
          }
      },
      setFacilitySeq(index) {
        return parseInt(index) + 1;
      },
      addFacility() {
        //  add facility when user click '+'
        this.form.facilities.push(
          {
            "facility_number": '',
            "facility_name": '',
            "sites": [],
            "allSites": [],
          }
        );
      },
      delFacility(index) {
        //  del facility when user click 'x'
        if (this.form.facilities.length === 1) {
          this.facilityError = 'At lease one Facility should be selected!';
        } else {
          this.facilityError = '';
          this.form.facilities.splice(index, 1);
        }
      },
      getFacility(value, index) {
        value = zeroPad(''+value, 6);
        this.form.facilities[index].facility_number = value;
        //  Get facility name if facility number is existed in DB;
        this.$store.dispatch(GET_FACILITY_INFO, value)
          .then(response => {
            if (response === undefined) {
              this.$notify({
                title: 'Error',
                text: 'Facility number is invalid.',
                type: 'error'
              });
              this.delFacility(index);
            }
            else if (this.checkDuplicateFacility(response.facility_number, index) === true) {
              this.$notify({
                title: 'Error',
                text: 'Duplicate facilities are not allowed.',
                type: 'error'
              });
              this.delFacility(index);
            }
            else {
              this.setFacility(response, index);
            }
          });
      },
      getCommitteeNames() {
        this.$store.dispatch(GET_COMMITTEE_NAMES)
          .then(response => {
            if (response.success) {
              this.committees = response.data;
            }
          });
      },
      getPublicationCat() {
        this.$store.dispatch(GET_ALL_PUBLICATION_CATEGORIES)
          .then(response => {
            if (response) {
              this.publication_categories = response.data;
            }
          });
      },
      setFacility(data, index) {
        //  set facility name and make the input not editable
        this.form.facilities[index].facility_name = data.name;
        document.getElementById('facility ' + index).value = data.name;
        this.form.facilities[index].allSites = data.sites;
      },
      checkDuplicateFacility(facility_number, index) {
        //  check if duplicate value exists.
        let checkDup = false;
        Object.values(this.form.facilities).forEach(function (value, key) {
          if (value.facility_number === facility_number && key !== index) {
            checkDup = true;
          }
        });
        return checkDup;
      },
      formatFacility(params) {
        let result = [];
        for (let key in params) {
          if (key === 'facility_number') {
            let title = 'Facility Accreditation Number';
            let obj = {
              'title': title,
              'desc': params[key]
            };
            result.push(obj);
          } else if (key === 'facility_name') {
            let title = 'Facility Name';
            let obj = {
              'title': title,
              'desc': params[key]
            };
            result.push(obj);
          } else if (key === 'sites') {
            var sites = '';
            for (let k in params[key]) {
              sites += (params[key][k]['value']) + ','
            }
            let title = 'Site Number and Site Name';
            let obj = {
              'title': title,
              'desc': sites
            };
            result.push(obj);
          }
        }
        return result;
      },
      containsObject(obj, list, idOnly) {
        if (idOnly) {
          for (let i = 0; i < list.length; i++) {
            if (obj.id === list[i].id) {
              return true
            }
          }
        } else {
          for (let i = 0; i < list.length; i++) {
            if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
              return true;
            }
          }
        }
        return false;
      },
      valueExistInObjArray(value, array) {
        return array.some(elem => elem.id === value)
      },
      showTerms() {
        this.showModal = true;
        this.ModalTitle = 'Terms and Conditions';
        this.ModalBody = htmlConstants.TERMS_AND_CONDITIONS;
      },
      formatCheckboxList(categories){
        let result = [];
        for(let category of categories){
          let cat = {};
          cat.id = category.id;
          cat.value = category.name;
          cat.items = [];
          if(category.children){
            for(let child of category.children){
              let subCat = {};
              subCat.id = child.id;
              subCat.value = child.name;
              cat.items.push(subCat);
            }
          }
          result.push(cat)
        }
        return result;
      },
      userSubscriptionChange(evt) {
        this.updatedSubscription = evt;
      }
    },
  };
</script>
